export const isIncorrectLabelFormat = (text: string) => {
	const regexp = /[~`'"!?@#$^&\s<>[\]+:|/\\]/g;
	if (text.match(regexp)) {
		return true;
	} else {
		return false;
	}
};
